module.exports = __webpack_public_path__ + "static/media/telkom-akses.bc1d4b9f.png";